module.exports = __webpack_public_path__ + "static/media/Logo__XBOX.ccb8c2cf.svg";